module.exports = __webpack_public_path__ + "static/img/06.7d6b8ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/06.jpg
// module id = lbMJ
// module chunks = 0